import { Footer } from "../../components/footer";

const Whitepaper = () => {


    return (
        <div>
            <div className="mainContent " style={{ width: '100%', height: '100%', }}>
                <div className="pageContent def-py-30" >
                    <div className="container" >

                        <iframe
                            title="PDF Preview"
                            src="https://thepill-live.s3.amazonaws.com/The-PillToken.pdf"
                            style={{ width: '100%', height: '100vh', border: 'none' }}

                        ></iframe>

                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );

}

export default Whitepaper;